import { Action } from 'redux';

import { ScheduleSingleFlowTask } from '~src/bootstrap/redux/actions/AppActionTypes';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { ISpaceItemDetailInfo } from '~src/spacesPlatform/models/ISpaceItemDetailInfo';

export interface ScheduleSingleFlowTaskReduxAction extends Action {
  readonly flow: IContentInfo;
}

export function scheduleSingleFlowTaskAction(flow: IContentInfo | ISpaceItemDetailInfo<'flow'>): ScheduleSingleFlowTaskReduxAction {
  return {
    type: ScheduleSingleFlowTask,
    flow
  };
}
